<script>
	let feeds = [];

	async function getFeeds() {
		const URL = "https://rss-aggregator.gramolelli.it/api/v1/feeds"
		const res = await fetch(URL,
		{
			method: 'GET'
		}
		)
		feeds = await res.json()
		console.log(feeds.length)
		if (res.ok) {
			return feeds;
		} else {
			throw new Error(feeds);
		}
	}

</script>



<style>
	:root {
		--main-color: #e7e4db;
		--main-background-color: rgb(38, 43, 48);
		--main-hyperlink: #75b6e7;
		--main-hyperlink-complementary: #e7a675;
		}

	main {
		text-align: left;
		/* padding: 1em; */
		/* margin: 0 auto; */
		background-color: var(--main-background-color);
		color: bisque;
	}

	/* @media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */

	nav {
		background-color: var(--main-hyperlink-complementary);
		padding: 10px;
		text-align: center;
		width: 100%;
		position: fixed;
		top: 0px;
		font-size: 1.2em;
	}
	
	ol {
		padding: 10px;
	}

	ol li {
		list-style-type: none;
		counter-increment: item;
		margin: 10px 0;
		font-size: 1.2em;
	}

	a {
		color: var(--main-hyperlink);
	}

	ol li:before {
		content: counter(item);
		margin-right: 5px;
		font-size: 80%;
		background-color: var(--main-color);
		color: var(--main-background-color);
		font-weight: bold;
		padding: 3px 8px;
		border-radius: 3px;
	}

	.feeds {
		padding-top: 20px;
	}
</style>

<nav>
	<b>{#if feeds.length > 0}{feeds.length}{/if} RSS FEEDS</b>
</nav>
<main>
	<div class="feeds">
		{#await getFeeds()}
		<p>loading...</p>
		{:then feeds}
			<ol>
				{#each feeds as feed}
					<li>
						<a href="{feed.link}">{feed.title}</a>
					</li>
				{/each}
			</ol>
		{:catch error}
			<p style="color: red">{error.message}</p>
		{/await}
	</div>
</main>